'use strict';

var $    = require('jquery');
var _    = require('underscore');
var Core = require('../core/core.js');
var InspectorSelectboxCustomOption = require('./inspector__selectbox__custom__option.js');

/**
 * Creates an inspector with selectbox
 *
 * @class
 */

class InspectorSelectboxCustom extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
        'selectedText': '',
        'selectedValue': ''
      }
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__item__select__custom js-inspector__select__container">
        <a class="editor__inspector__item__select__custom__selected js-inspector__select__selected" href="#" data-value="<%- selectedValue %>">
          <div>
              <span class="editor__inspector__item__select__custom__text js-inspector__select__selected__text"><%- selectedText %></span>
              <span class="editor__inspector__item__select__custom__selected__arrow">&#x25BE;</span>
          </div>
        </a>
        <div class="editor__inspector__item__select__custom__listContainer js-inspector__select__list__container">
          <ul class="editor__inspector__item__select__custom__list js-inspector__select__list"></ul>
        </div>
      </div>
		`;

		super.render();

    this.hide();

		this.customOpts = [];

    $('.js-inspector__select__selected', this.$el).on('click', this._toggleOptions);
    $('.js-inspector__select__list__container', this.$el).css('width', this.$el.width());

    $(document).bind('click', function(e) {
        var $clicked = $(e.target);
        if (! $clicked.parents().hasClass("js-inspector__select__container"))
            $(".editor__inspector__item__select__custom__listContainer").slideUp();
    });

	}

	/**
	* setValue
	*
	* @param {string} value - the value that you want to set
	*/

	setValue(text, value){
    $('.js-inspector__select__selected__text', this.$el).data('value', value).html(text);
	}

	chooseOption(value){
		for (var idx in this.customOpts) {
			if (value === this.customOpts[idx].val) {
				this.customOpts[idx].selectOption();
			} else {
				this.customOpts[idx].deselectOption();
			}
		}
	}

  _toggleOptions(e) {
    e.preventDefault();
    $(e.currentTarget)
      .siblings('.js-inspector__select__list__container')
      .slideToggle();
  }

	addOption(selectbox, custombox, option){
		var newCustomOpt = new InspectorSelectboxCustomOption({
			target: this.$el.find('.js-inspector__select__list'),
			fields: {
        'selectbox': selectbox,
        'custombox': custombox,
        'option': option
      }
		});
		this.customOpts.push(newCustomOpt);
		return newCustomOpt;
	}

  hide() {
    $(".js-inspector__select__list__container", this.$el).hide();
  }

}
module.exports = InspectorSelectboxCustom;
